import { TermPolicyStatus } from '@store/term-status/types';

export const isTermProposalSubmitted = (status: TermPolicyStatus) => {
  return status === TermPolicyStatus.FORM_SUBMITTED;
};
